module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-option-7days-2c0af8463da09e27b2f06521b467dffe.jpg";